import {BusinessPartner, IBusinessPartner} from '@service-and-repairs/awpintegrationlib';
import {UserInfo} from '../interfaces/user-info';
import {
  MileageUnit,
  PressureUnit,
  TemperatureUnit,
  TreadDepthUnit,
  UserSettings,
  VolumeUnit
} from '../interfaces/user-settings';
import {UserData} from './user-data';

export class UserMapper {
  static fromUserInfo(userInfo: UserInfo): UserData {
    const settings: UserSettings = userInfo.userSettings;
    const user: UserData = new UserData();
    user.setId(userInfo.id);
    user.setName(userInfo.firstName + ' ' + userInfo.lastName);
    user.setLoginName(userInfo.loginName);
    user.setSettingsId(settings.id);
    user.setContext(userInfo.businessContext);
    user.setLocale(settings.systemLanguage);
    user.setEmail(userInfo.email);
    user.setPhone(userInfo.phoneNumber);
    user.setDefaultApp(settings.defaultApp);
    user.setMileageUnit(settings.mileageUnit || 'km');
    user.setVolumeUnit(settings.volumeUnit || 'l');
    user.setTemperatureUnit(settings.temperatureUnit || 'C');
    user.setPressureUnit(settings.pressureUnit || 'bar');
    user.setTreadDepthUnit(settings.treadDepthUnit || 'mm');
    user.setNewCaseAfterVehicleIdentification(settings.newCaseAfterVehicleIdentification);
    user.setRoles(userInfo.roles);
    user.setOutletPeers(userInfo.outletPeers);
    user.setCaseTabShowCustomer(settings.caseTabShowCustomer);
    user.setCaseTabShowModel(settings.caseTabShowModel);
    user.setCaseTabShowTitle(settings.caseTabShowTitle);
    user.setCaseTabShowVin(settings.caseTabShowVin);
    user.setAddedQuantityStrategy(settings.addedQuantityStrategy);
    user.setDefaultPartsSearchBrand(settings.defaultPartsSearchBrand);
    user.setShowPicturePanelTreeSearch(settings.showPicturePanelTreeSearch);
    user.setShowPartNumbers(settings.showPartNumbers);
    user.setShowRetrofittableParts(settings.showRetrofittableParts);
    user.setShowOmittedParts(settings.showOmittedParts);
    user.setAutoExpandExpandableSections(settings.autoExpandExpandableSections);
    user.setPartsDmsEmployeeNumber(settings.partsDmsEmployeeNumber);
    user.setPartsDmsUserPassword(settings.partsDmsUserPassword);
    user.setRequestPartLocation(settings.requestPartLocation);
    user.setDmsUsername(settings.dmsUserId);
    user.setDmsPassword(settings.dmsUserPassword);
    user.setDmsServiceAdvisorId(settings.dmsServiceAdvisorId);
    user.setEshWriteMode(settings.eshWriteMode || 'ASK');
    user.setBusinessPartners(userInfo.businessPartners.map((partner: object): IBusinessPartner =>
      BusinessPartner.constructFromPlainObject(partner)));
    user.setSelectedBusiness(settings.selectedBusinessPartnerId, settings.selectedVehicleType);
    user.setKeyReaderId(settings.keyReaderId);
    return user;
  }

  static toUserSettings(user: UserData): UserSettings {
    return {
      id: user.getSettingsId(),
      businessContext: user.getContext(),
      caseTabShowCustomer: user.getCaseTabShowCustomer(),
      caseTabShowModel: user.getCaseTabShowModel(),
      caseTabShowTitle: user.getCaseTabShowTitle(),
      caseTabShowVin: user.getCaseTabShowVin(),
      defaultApp: user.getDefaultApp(),
      dmsUserPassword: user.getDmsPassword(),
      dmsUserId: user.getDmsUsername(),
      dmsServiceAdvisorId: user.getDmsServiceAdvisorId(),
      keyReaderId: user.getKeyReaderId(),
      mileageUnit: user.getMileageUnit() as MileageUnit,
      newCaseAfterVehicleIdentification: user.getNewCaseAfterVehicleIdentification(),
      selectedBusinessPartnerId: user.getBusinessPartner().getBusinessPartnerId(),
      selectedVehicleType: user.getSelectedVehicleType(),
      systemLanguage: user.getLocale(),
      temperatureUnit: user.getTemperatureUnit() as TemperatureUnit,
      userId: user.getId(),
      volumeUnit: user.getVolumeUnit() as VolumeUnit,
      pressureUnit: user.getPressureUnit() as PressureUnit,
      treadDepthUnit: user.getTreadDepthUnit() as TreadDepthUnit,
      addedQuantityStrategy: user.getAddedQuantityStrategy(),
      defaultPartsSearchBrand: user.getDefaultPartsSearchBrand(),
      showPicturePanelTreeSearch: user.getShowPicturePanelTreeSearch(),
      showPartNumbers: user.getShowPartNumbers(),
      showRetrofittableParts: user.getShowRetrofittableParts(),
      showOmittedParts: user.getShowOmittedParts(),
      autoExpandExpandableSections: user.getAutoExpandExpandableSections(),
      partsDmsEmployeeNumber: user.getPartsDmsEmployeeNumber(),
      partsDmsUserPassword: user.getPartsDmsUserPassword(),
      requestPartLocation: user.getRequestPartLocation(),
      eshWriteMode: user.getEshWriteMode()
    };
  }
}
